module.exports = __webpack_public_path__ + "files/59c59d1a716d8c129404256cb9337df7.png";